// Based on https://codepen.io/ganmahmud/pen/RaoKZa

(() => {
  App.components = App.components || {};

  const name = 'swipeDetect';

  App.components[name] = ((() => {
    const detect = (el, callback) => {
      const touchsurface = el;
      let swipedir;
      let startX;
      let startY;
      let distX;
      let distY;
      const threshold = 30; // required min distance traveled to be considered swipe
      const restraint = 150; // maximum distance allowed at the same time in perpendicular direction
      const allowedTime = 300; // maximum time allowed to travel that distance
      let elapsedTime;
      let startTime;
      const handleswipe = callback || (() => {});

      touchsurface.addEventListener('touchstart', (e) => {
        const touchobj = e.changedTouches[0];
        swipedir = 'none';
        startX = touchobj.pageX;
        startY = touchobj.pageY;
        // record time when finger first makes contact with surface
        startTime = new Date().getTime();
      }, false);

      touchsurface.addEventListener('touchend', (e) => {
        const touchobj = e.changedTouches[0];
        // get horizontal dist traveled by finger while in contact with surface
        distX = touchobj.pageX - startX;
        // get vertical dist traveled by finger while in contact with surface
        distY = touchobj.pageY - startY;
        // get time elapsed
        elapsedTime = new Date().getTime() - startTime;
        if (elapsedTime <= allowedTime) { // first condition for swipe met
          // 2nd condition for horizontal swipe met
          if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
            // if dist traveled is negative, it indicates left swipe
            swipedir = (distX < 0) ? 'left' : 'right';
            // 2nd condition for vertical swipe met
          } else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) {
            // if dist traveled is negative, it indicates up swipe
            swipedir = (distY < 0) ? 'up' : 'down';
          }
        }
        handleswipe(swipedir);
      }, false);
    };

    return {
      detect,
    };
  })());
})();
